export default __webpack_public_path__ + "static/media/447.9df02687.png";